var _defs, _rect, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg03QualityAssurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 190",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #f6f6e0;\n      }\n\n      .cls-3 {\n        fill: #bfbe91;\n      }\n\n      .cls-4 {\n        fill: #e4e4e4;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-7 {\n        stroke-width: .32px;\n      }\n\n      .cls-7, .cls-8 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-8 {\n        stroke-width: .6px;\n      }\n\n      .cls-9 {\n        fill: #1766d6;\n      }\n\n      .cls-10 {\n        fill: #d3dfff;\n      }\n\n      .cls-11 {\n        fill: #1860d3;\n      }\n\n      .cls-12, .cls-13 {\n        opacity: .25;\n      }\n\n      .cls-14 {\n        fill: #f6f5f5;\n      }\n\n      .cls-15 {\n        opacity: .15;\n      }\n\n      .cls-15, .cls-13 {\n        fill: #231f20;\n      }\n\n      .cls-16 {\n        fill: #a5a37a;\n      }\n\n      .cls-17 {\n        fill: #708cd5;\n      }\n\n      .cls-18 {\n        fill: #00b3ea;\n      }\n\n      .cls-19 {\n        fill: #f29f28;\n      }\n\n      .cls-20 {\n        fill: #ebecf2;\n        opacity: .5;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -8141.54,
    y1: 137.17,
    x2: -8101.85,
    y2: 137.17,
    gradientTransform: "translate(-8068.73) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d35400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb62d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -8117.74,
    xlinkHref: "#linear-gradient"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -1.64,
    y: -1.2,
    width: 303.28,
    height: 192.41
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M238.32,61.23h0c1.29.64,2.33,0,2.34-1.43l.19-13.4c0-1.43-1.03-3.11-2.31-3.75h0c-1.29-.64-2.33,0-2.34,1.43l-.19,13.4c0,1.43,1.03,3.11,2.31,3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M236.2,44.08c0-1.43,1.06-2.07,2.34-1.43,1.29.64,2.32,2.32,2.31,3.75,0,1.43-1.06,2.07-2.34,1.43-1.29-.64-2.32-2.32-2.31-3.75Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M237.41,64.69h0c0,1.13.81,2.45,1.83,2.96l23.39,11.68c1.01.51,1.84,0,1.85-1.13h0c0-1.13-.81-2.45-1.83-2.96l-23.39-11.68c-1.01-.51-1.84,0-1.85,1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M239.24,67.65c-1.01-.51-1.83-1.83-1.83-2.96,0-1.13.83-1.63,1.85-1.13,1.01.51,1.83,1.83,1.83,2.96,0,1.13-.83,1.63-1.85,1.13Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "257.96 35.28 258.04 50.28 245.72 46.83 254.94 45.94 257.96 35.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "257.96 35.28 258.04 50.28 270.4 54.13 261.34 47.31 257.96 35.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "257.96 35.28 258.04 50.28 270.41 54.13 261.34 47.31 257.96 35.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "258.04 50.28 257.97 68.6 254.23 53.3 245.72 46.83 258.04 50.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "258.04 50.28 257.98 68.6 254.23 53.3 245.72 46.83 258.04 50.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "270.4 54.13 258.04 50.28 257.97 68.6 260.83 55.57 270.4 54.13"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "248.55 51.92 248.57 56.96 244.43 55.8 247.53 55.51 248.55 51.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "248.55 51.92 248.57 56.96 252.73 58.26 249.68 55.97 248.55 51.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "248.55 51.92 248.57 56.96 252.73 58.26 249.68 55.97 248.55 51.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "248.57 56.96 248.55 63.12 247.29 57.98 244.43 55.8 248.57 56.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "248.57 56.96 248.55 63.12 247.29 57.98 244.43 55.8 248.57 56.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "252.73 58.26 248.57 56.96 248.55 63.12 249.51 58.74 252.73 58.26"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 100.89,
    y: 31.18,
    width: 105.63,
    height: 144.9,
    rx: 5.87,
    ry: 5.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 110.24,
    y: 42.33,
    width: 86.95,
    height: 126.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 130.67,
    y: 50.92,
    width: 45.75,
    height: 6.97,
    transform: "translate(1.32 -3.6) rotate(1.35)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 144.01,
    y: 68.02,
    width: 41.27,
    height: 3.19,
    transform: "translate(1.68 -3.85) rotate(1.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 143.85,
    y: 74.82,
    width: 28.05,
    height: 3.19,
    transform: "translate(1.84 -3.69) rotate(1.35)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 143.59,
    y: 85.69,
    width: 33.98,
    height: 3.19,
    transform: "translate(2.1 -3.75) rotate(1.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 143.43,
    y: 92.73,
    width: 41.27,
    height: 3.19,
    transform: "translate(2.26 -3.83) rotate(1.35)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 123.54,
    y: 65.58,
    width: 14.03,
    height: 13.37,
    transform: "translate(1.74 -3.05) rotate(1.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 123.35,
    y: 83.95,
    width: 14.03,
    height: 13.37,
    transform: "translate(2.17 -3.04) rotate(1.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 122.7,
    y: 101.36,
    width: 14.03,
    height: 13.37,
    transform: "translate(2.58 -3.02) rotate(1.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 122.27,
    y: 119.62,
    width: 14.03,
    height: 13.37,
    transform: "translate(3.01 -3.01) rotate(1.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 122.27,
    y: 137.89,
    width: 14.03,
    height: 13.37,
    transform: "translate(3.44 -3) rotate(1.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M126.24,70.72c.3,1.15.86,5.99,3.28,4.64.56-.31,1.03-1.14,1.45-1.61.75-.85,1.5-1.71,2.25-2.56,1.5-1.71,3-3.41,4.51-5.12.38-.44-1.31-1.53-1.8-.98-1.33,1.52-2.67,3.03-4,4.55-.67.76-1.33,1.52-2,2.27-.46.53-1.53,2.22-2.22,2.37.37.12.75.24,1.12.36.26.22-.23-1.32-.24-1.36-.19-.71-.37-1.43-.56-2.14-.15-.59-2.01-1.3-1.79-.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M125.54,89.45c.3,1.15.86,5.99,3.28,4.64.56-.31,1.03-1.14,1.45-1.61.75-.85,1.5-1.71,2.25-2.56,1.5-1.71,3-3.41,4.51-5.12.38-.44-1.31-1.53-1.8-.98-1.33,1.52-2.67,3.03-4,4.55-.67.76-1.33,1.52-2,2.27-.46.53-1.53,2.22-2.22,2.37.37.12.75.24,1.12.36.26.22-.23-1.32-.24-1.36-.19-.71-.37-1.43-.56-2.14-.15-.59-2.01-1.3-1.79-.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M125.54,106.3c.3,1.15.86,5.99,3.28,4.64.56-.31,1.03-1.14,1.45-1.61.75-.85,1.5-1.71,2.25-2.56,1.5-1.71,3-3.41,4.51-5.12.38-.44-1.31-1.53-1.8-.98-1.33,1.52-2.67,3.03-4,4.55-.67.76-1.33,1.52-2,2.27-.46.53-1.53,2.22-2.22,2.37.37.12.75.24,1.12.36.26.22-.23-1.32-.24-1.36-.19-.71-.37-1.43-.56-2.14-.15-.59-2.01-1.3-1.79-.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M124.61,124.16c.3,1.15.86,5.99,3.28,4.64.56-.31,1.03-1.14,1.45-1.61.75-.85,1.5-1.71,2.25-2.56,1.5-1.71,3-3.41,4.51-5.12.38-.44-1.31-1.53-1.8-.98-1.33,1.52-2.67,3.03-4,4.55-.67.76-1.33,1.52-2,2.27-.46.53-1.53,2.22-2.22,2.37.37.12.75.24,1.12.36.26.22-.23-1.32-.24-1.36-.19-.71-.37-1.43-.56-2.14-.15-.59-2.01-1.3-1.79-.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M124.61,143.51c.3,1.15.86,5.99,3.28,4.64.56-.31,1.03-1.14,1.45-1.61.75-.85,1.5-1.71,2.25-2.56,1.5-1.71,3-3.41,4.51-5.12.38-.44-1.31-1.53-1.8-.98-1.33,1.52-2.67,3.03-4,4.55-.67.76-1.33,1.52-2,2.27-.46.53-1.53,2.22-2.22,2.37.37.12.75.24,1.12.36.26.22-.23-1.32-.24-1.36-.19-.71-.37-1.43-.56-2.14-.15-.59-2.01-1.3-1.79-.42h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 143.17,
    y: 103.53,
    width: 41.27,
    height: 3.19,
    transform: "translate(2.52 -3.83) rotate(1.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 143.01,
    y: 110.22,
    width: 18.46,
    height: 3.19,
    transform: "translate(2.67 -3.55) rotate(1.35)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 142.76,
    y: 121.29,
    width: 41.27,
    height: 3.19,
    transform: "translate(2.94 -3.81) rotate(1.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 142.59,
    y: 128.14,
    width: 32.6,
    height: 3.19,
    transform: "translate(3.1 -3.7) rotate(1.35)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 142.35,
    y: 138.62,
    width: 16.36,
    height: 3.19,
    transform: "translate(3.34 -3.5) rotate(1.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M183.48,146.35l-41.26-.97-.08,3.19c15.96.37,36.28,1.12,40.43.49.63-.72.97-1.59.9-2.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M173.63,33.77v9.75h-39.16v-9.75c0-1.55.63-2.96,1.65-3.98.13-.13.26-.25.4-.36.97-.81,2.22-1.29,3.58-1.29,1.02,0,2-.23,2.88-.66.38-.18.74-.4,1.08-.65,1.12-.83,1.98-2.01,2.4-3.41.43-1.43,1.32-2.63,2.48-3.46,1.11-.8,2.46-1.25,3.89-1.25h2.44c1.43,0,2.78.46,3.89,1.25,1.15.83,2.04,2.03,2.48,3.46.43,1.4,1.28,2.58,2.4,3.41.34.25.7.47,1.08.65.88.42,1.86.66,2.88.66,1.36,0,2.61.48,3.58,1.29,1.25,1.03,2.05,2.59,2.05,4.34Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "176.81 38.73 176.81 45.98 131.28 45.98 131.28 38.73 134.46 38.73 134.46 43.52 173.63 43.52 173.63 38.73 176.81 38.73"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 154.05,
    cy: 24.55,
    rx: 3.47,
    ry: 3.3
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M72.81,147.18l-2.45.68h-23.51c-.43,0-.79-.36-.79-.79v-13.54c0-.43.36-.79.79-.79h14.88s11.09,14.44,11.09,14.44Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "33.12 158.14 49.03 116.2 72.81 147.18 33.12 158.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.12,158.14c0-.94.28-22.48.28-22.48l15.61-19.47-15.89,41.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M33.12,158.14c0-.94.28-22.48.28-22.48l15.61-19.47-15.89,41.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M33.12,148.16c0-.52.15-12.41.15-12.41l8.62-10.75-8.78,23.16Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M72.81,147.18l-2.45.68h-23.51c-.43,0-.79-.36-.79-.79v-13.54c0-.43.36-.79.79-.79h14.88s11.09,14.44,11.09,14.44Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 48.04,
    y: 124.55,
    width: 41.51,
    height: 21.16,
    rx: 3.56,
    ry: 3.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 49.54,
    y: 126.07,
    width: 38.87,
    height: 18.3,
    rx: 1.71,
    ry: 1.71,
    transform: "translate(137.94 270.44) rotate(-180)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 49.54,
    y1: 130.47,
    x2: 84.12,
    y2: 130.47
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 52.27,
    cy: 128.51,
    rx: 0.84,
    ry: 0.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 54.96,
    cy: 128.51,
    rx: 0.84,
    ry: 0.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M58.42,128.51c0-.46-.38-.83-.84-.83s-.84.37-.84.83c0,.46.38.83.84.83.46,0,.84-.37.84-.83Z"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "51.08 142.71 58.32 134.87 64.36 140.2 71.82 133.95 78.01 137.08 81.68 134.81"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 83.15,
    cy: 133.85,
    r: 1.66
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03QualityAssurance);
export default __webpack_public_path__ + "static/media/03 Quality Assurance.5873e390f3ad6ff064200234359ef3c1.svg";
export { ForwardRef as ReactComponent };